/* eslint-disable */
(function () {
  if (typeof window === 'undefined') {
    return;
  }

  if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
      value: function (predicate) {
        // 1. Let O be ? ToObject(this value).
        if (this == null) {
          throw new TypeError('"this" is null or not defined');
        }

        var o = Object(this);

        // 2. Let len be ? ToLength(? Get(O, "length")).
        var len = o.length >>> 0;

        // 3. If IsCallable(predicate) is false, throw a TypeError exception.
        if (typeof predicate !== 'function') {
          throw new TypeError('predicate must be a function');
        }

        // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
        var thisArg = arguments[1];

        // 5. Let k be 0.
        var k = 0;

        // 6. Repeat, while k < len
        while (k < len) {
          // a. Let Pk be ! ToString(k).
          // b. Let kValue be ? Get(O, Pk).
          // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
          // d. If testResult is true, return kValue.
          var kValue = o[k];
          if (predicate.call(thisArg, kValue, k, o)) {
            return kValue;
          }
          // e. Increase k by 1.
          k++;
        }

        // 7. Return undefined.
        return undefined;
      }
    });
  }

  function getQueryString(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
      return unescape(r[2]);
    }
    return null;
  }

  var initSender = function () {
    return (navigator.sendBeacon && navigator.sendBeacon.bind(navigator)) || function (url) {
      new Image().src = url;
    };
  };

  function Channel () {
    // this.init();
  };

  Channel.prototype.channelMap = [{
    channel: 'OPPO',
    pids: ['1383', '1384', '1385']
  }, {
    channel: 'FQL',
    pids: ['1369', '1403']
  }, {
    channel: 'HWELS',
    pids: ['1', '2']
  }];

  Channel.prototype.getChannelByPid = function (pid) {
    var channel = this.channelMap.find(function (channel) {
      return channel.pids.indexOf(pid) > -1;
    });
    return channel ? channel.channel : 'HSBPC';
  };

  Channel.prototype.getPid = function () {
    return getQueryString('pid') || '1001';
  };

  function Page (params) {
    this.init(params);
  };

  Page.prototype.init = function (params) {
    this.invokeMap = params.invokeMap;
  };

  Page.prototype.getInvokeInfoByPath = function (p) {
    p = p || window.location.pathname;
    return this.invokeMap.find(function (info) {
      var re = new RegExp(info.path, 'i');
      return re.test(p);
    }) || {};
  };

  Page.prototype.getReferrer = function () {
    var referrer = '';
    try {
      referrer = window.top.document.referrer;
    } catch (e) {
      if (window.parent) {
        try {
          referrer = window.parent.document.referrer;
        } catch (e2) {
          referrer = '';
        }
      }
    }
    if (referrer === '') {
      referrer = document.referrer;
    }
    return referrer;
  };

  Page.prototype.resolve = function (href) {
    var location = document.createElement('a');
    location.href = href;
    // IE doesn't populate all link properties when setting .href with a relative URL,
    // however .href will return an absolute URL which then can be used on itself
    // to populate these additional fields.
    if (location.host == '') {
      location.href = location.href;
    }
    return location;
  };

  function Statistics (params) {
    this.init(params);
  };

  Statistics.prototype.init = function (params) {
    this.VERSION = '2';
    this.channel = new Channel();
    this.page = new Page(params);
    this.spaMode = params.spaMode;
    this.setStartTime();
    this.send = initSender();

    if (this.spaMode) {
      this.registerHistoryHandler();
    }

    this.registerEnvent();
  };

  Statistics.prototype.registerEnvent = function () {
    window.addEventListener('unload', this.pageChanged.bind(this));
  };

  Statistics.prototype.setStartTime = function () {
    this.startTime = new Date().getTime();
  };

  Statistics.prototype.getTimeSpent = function () {
    if (!window.performance || !window.performance.timing || !window.performance.timing.domComplete) {
      return 0;
    }
    
    return +new Date - this.startTime;
  };

  Statistics.prototype.pageChanged = function (params) {
    var params = this.getPvPrams();
    if (!params.caller || !params.channel || !params.callee) {
      return;
    }
    this.send('https://logreport.huishoubao.com/hjxapps/?' + params.join('='));
    this.setStartTime();
  };

  Statistics.prototype.getPvPrams = function () {
    var params = [];
    var path = window.location.pathname;
    var calleeInfo = this.page.getInvokeInfoByPath(path);
    var callee = calleeInfo.name;
    // var $caller = this.page.getInvokeInfoByPath(this.page.resolve(this.page.getReferrer()).pathname).name;
    var caller = /* ($caller !== callee && $caller) ||  */calleeInfo.caller || 'Main';
    var pid = this.channel.getPid();
    var channel = this.channel.getChannelByPid(pid);
    var prefix = 'PV_' + channel + '_';

    params[0] = this.VERSION;
    params[1] = parseInt(+new Date() / 1000);
    params[2] = prefix + caller;
    params[3] = path;
    params[4] = prefix + callee;
    params[5] = channel;
    params[6] = callee;
    params[7] = pid;
    params[8] = this.getTimeSpent();

    params.caller = caller;
    params.callee = callee;
    params.channel = channel;

    return params;
  };

  Statistics.prototype.registerHistoryHandler = function () {
    var pushState = window.history.pushState;
    var replaceState = window.history.replaceState;
    if (!pushState) {
      return;
    }
    var prevUrl = this.page.getReferrer();
    var handler = this.pageChanged.bind(this);
    'function' == typeof Object.defineProperty && Object.defineProperty(document, "referrer", {
      get: function () {
        return prevUrl
      },
      configurable: !0,
    });

    window.history.pushState = function (e) {
      prevUrl = window.location.toString();
      setTimeout(function () {
        handler();
      }, 0);
      return pushState.apply(window.history, arguments);
    };

    window.history.replaceState = function (e) {
      prevUrl = window.location.toString();
      setTimeout(function () {
        handler();
      }, 0);
      return replaceState.apply(window.history, arguments);
    };
  };

  var invokeMap = [{
    name: 'Product',
    path: '/products/?',
    caller: 'Index'
  }, {
    name: 'Evaluate',
    path: '/evaluate/\\d+',
    caller: 'Product'
  }, {
    name: 'Evaluate',
    path: '/productInfo/\\d+',
    caller: 'Product'
  }, {
    name: 'AssessPrice',
    path: '/evInfo/',
    caller: 'Evaluate'
  }, {
    name: 'PlaceOrder',
    path: '/initOrder/',
    caller: 'AssessPrice'
  }, {
    name: 'Success',
    path: '/orderCompletion/',
    caller: 'PlaceOrder'
  }, {
    name: 'Success',
    path: '/orderResult/',
    caller: 'PlaceOrder'
  }, {
    name: 'Index',
    path: '^/$|^/\\w+/?$'
  }];

  try {
    new Statistics({
      invokeMap: invokeMap,
      spaMode: true
    });
  } catch (err) {
    console.log(err);
  }
})();
